module.exports = __webpack_public_path__ + "img/clock.fe3f251a.svg";